import {createBrowserHistory} from "history"
import {Portal, PortalRoute} from "scholastic-client-components/src/types/securityTypes"
import {ReferrerSearchParams} from "scholastic-client-components/src/lib/routing"

export const history = createBrowserHistory({
    basename: import.meta.env.BASE_URL,
})
export type HistoryParamValue = string | undefined | null

export const redirectToReferrer = (): void => {
    const urlParams = new URLSearchParams(history.location.search)
    const referrerURL = urlParams.get(ReferrerSearchParams.URL)
    window.location.replace(
        referrerURL ? decodeURIComponent(referrerURL) : PortalRoute[Portal.Home]
    )
}

export enum Form {
    Device = "deviceForm",
    NewlineUser = "newlineUserForm",
    Account = "accountForm",
}

export enum UrlParams {
    DeviceId = "id",
    Token = "token",
    Step = "step",
    Type = "type",
    District = "district",
    School = "school",
    Company = "company",
    Building = "building",
    CanvaUser = "user",
    CanvaState = "state",
    CanvaBrand = "brand",
    CanvaExtensions = "extensions",
    CanvaTime = "time",
    CanvaSignatures = "signatures",
}

export enum AppPaths {
    Login = "/login",
    LoginSSO = "/log_in_sso",
    SSOSuccess = "/sso_success",
    SSOFailure = "/sso_failure",
    ResetPassword = "/resetPassword",
    CreateNewlineUserAccount = "/createTrialAccount",
    ConfirmNewlineUserAccount = "/confirmTrialAccount",
    AlreadyConfirmed = "/already-confirmed",
    Device = "/device",
    Privacy = "/privacy-policy",
    Terms = "/terms_of_use",
    DataDeletion = "/data_deletion",
}

export const pushUrlHistoryParams =
    (history: any) => (params: {[paramName: string]: HistoryParamValue}) => {
        const urlSearchParams = new URLSearchParams(history.location.search)

        Object.entries(params).forEach(([paramName, paramValue]) => {
            if (paramValue) {
                urlSearchParams.set(paramName, paramValue)
            } else {
                urlSearchParams.delete(paramName)
            }
        })
        history.push({...history.location, search: urlSearchParams.toString()})
    }
